import { render, staticRenderFns } from "./Office.vue?vue&type=template&id=5c71feb0&scoped=true&"
import script from "./Office.vue?vue&type=script&lang=js&"
export * from "./Office.vue?vue&type=script&lang=js&"
import style0 from "./Office.vue?vue&type=style&index=0&id=5c71feb0&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c71feb0",
  null
  
)

export default component.exports